export * from "./EnumChoicesContext";
export * from "./EnumChoicesProvider";
export * from "./useEnumChoices";

import { useEnumChoices } from "./useEnumChoices";

export function useMeetingStatuses() {
  const { meetingStatuses } = useEnumChoices();
  return { meetingStatuses };
}

export function useAgendaItemStatuses() {
  const { agendaItemStatuses } = useEnumChoices();
  return { agendaItemStatuses };
}

export function useTaskStatuses() {
  const { taskStatuses } = useEnumChoices();
  return { taskStatuses };
}

export function useParticipantStatuses() {
  const { participantStatuses } = useEnumChoices();
  return { participantStatuses };
}

export function useParticipantRoles() {
  const { participantRoles } = useEnumChoices();
  return { participantRoles };
}
